import React, { useState, useEffect } from "react";
import { Dropdown, Row, Tab, Collapse } from "react-bootstrap";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Select from "react-select";
import DatePicker from "react-datepicker";
import {
  getPackageTypeReport,
  getPaymentHistroyReport,
  getPaymentModeReport,
  getTenantReport,
} from "../../../../services/ReportService";

const theadData = [
  { heading: "S.No", sortingVale: "sno" },
  { heading: "Tenant Name", sortingVale: "name" },
  { heading: "Email", sortingVale: "email" },
  { heading: "Mobile", sortingVale: "phone" },
  { heading: "Payment Mode", sortingVale: "paymentMode" },
  { heading: "Payment Type", sortingVale: "paymentType" },
  { heading: "Amount", sortingVale: "amount" },
  { heading: "Invoice No.", sortingVale: "invoiceNumber" },
  { heading: "Payment Date", sortingVale: "paymentDate" },
  { heading: "Status", sortingVale: "status" },
];

const PaymentHistoryReport = () => {
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState([]);

  // pagination & search
  const [page, setPage] = useState(0); // 0-based
  const [size, setSize] = useState(10); // page size
  const [search, setSearch] = useState(""); // search text
  const [totalElements, setTotalElements] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [currentStart, setCurrentStart] = useState(0);
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);

  // filters
  const [selectedTenant, setSelectedTenant] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState("");
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [open, setOpen] = useState(true);

  // tenant dropdown options & pagination
  const [tenantPage, setTenantPage] = useState(0);
  const [tenantOptions, setTenantOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [tenantSearch, setTenantSearch] = useState("");
  const pageSize = 20;

  const [iconData, setIconDate] = useState({ complete: false, ind: Number });

  const formatDate = (date) => {
    if (!date) return null;
    if (typeof date === "string" && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
      return date;
    }
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const loadTenants = async (pageToLoad = 0, search = "") => {
    if (isLoading) return;

    try {
      setIsLoading(true);

      const data = await getTenantReport(pageToLoad, pageSize, search);

      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.content)
        ? data.content
        : [];

      const newOptions = items.map((item) => ({
        label: item.name,
        value: item.id,
      }));

      if (pageToLoad === 0) {
        setTenantOptions(newOptions);
      } else {
        setTenantOptions((prev) => [...prev, ...newOptions]);
      }

      setTenantPage(pageToLoad);
      setHasMore(data?.last === false || (!data?.last && items.length === pageSize));
    } catch (error) {
      console.error("Error loading tenants:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTenants(0, "");
  }, []);

  // ---- API CALL WITH page, size, search, tenantId, paymentMode, paymentType, fromDate, toDate ----
  async function fetchUserData() {
    setLoading(true);
    try {
      const res = await getPaymentHistroyReport(
        page,
        size,
        search,
        selectedTenant?.value || "",
        selectedPaymentMode || "",
        selectedPaymentType || "",
        formatDate(startDate),
        formatDate(endDate),
      );
      setUserData(res?.content || []);
      setTotalElements(res?.totalElements || 0);
      setTotalPages(res?.totalPages || 0);
      setCurrentStart(res?.number || 0);
    } catch (error) {
      console.error("Error fetching payment history data:", error);
    } finally {
      setLoading(false);
    }
  }

  // initial & whenever filters change
  useEffect(() => {
    fetchUserData();
  }, [
    page,
    size,
    search,
    selectedTenant,
    selectedPaymentMode,
    selectedPaymentType,
    startDate,
    endDate,
  ]);

  // ---- client sorting ----
  function SotingData(name) {
    const sortedData = [...userData];
    switch (name) {
      case "name":
        sortedData.sort((a, b) => {
          const aVal = a?.tenant?.name || a?.tenantName || a?.name || "";
          const bVal = b?.tenant?.name || b?.tenantName || b?.name || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "email":
        sortedData.sort((a, b) => {
          const aVal = a?.tenant?.email || a?.email || "";
          const bVal = b?.tenant?.email || b?.email || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "phone":
        sortedData.sort((a, b) => {
          const aVal = a?.tenant?.phone || a?.phone || "";
          const bVal = b?.tenant?.phone || b?.phone || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "paymentMode":
        sortedData.sort((a, b) => {
          const aVal = a?.paymentMode || a?.modeOfPayment || "";
          const bVal = b?.paymentMode || b?.modeOfPayment || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "paymentType":
        sortedData.sort((a, b) => {
          const aVal = a?.paymentType || a?.subscriptionType || "";
          const bVal = b?.paymentType || b?.subscriptionType || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "amount":
        sortedData.sort((a, b) => {
          const aVal = Number(a?.amount ?? a?.price ?? 0);
          const bVal = Number(b?.amount ?? b?.price ?? 0);
          return iconData.complete ? aVal - bVal : bVal - aVal;
        });
        break;

      case "invoiceNumber":
        sortedData.sort((a, b) => {
          const aVal = a?.invoiceNumber || a?.invoiceNo || "";
          const bVal = b?.invoiceNumber || b?.invoiceNo || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      case "status":
        sortedData.sort((a, b) => {
          const aVal = a?.status || a?.paymentStatus || "";
          const bVal = b?.status || b?.paymentStatus || "";
          return iconData.complete
            ? aVal.localeCompare(bVal)
            : bVal.localeCompare(aVal);
        });
        break;

      default:
        break;
    }
    setUserData(sortedData);
  }

  // ---- Search handler ----
  function handleSearchChange(e) {
    const value = e.target.value;
    setSearch(value);
    setPage(0); // reset to first page on search
  }

  const downloadExcel = async () => {
    try {
      const res = await getPaymentHistroyReport(
        0,
        1000,
        search,
        selectedTenant?.value || "",
        selectedPaymentMode || "",
        selectedPaymentType || "",
        formatDate(startDate),
        formatDate(endDate),
      );

      const content = Array.isArray(res)
        ? res
        : Array.isArray(res?.content)
        ? res.content
        : [];

      const formattedData = content.map((data, index) => ({
        "S.No": index + 1,
        "Tenant Name": data?.tenant?.name || data?.tenantName || data?.name || "-",
        Email: data?.tenant?.email || data?.email || "-",
        Mobile: data?.tenant?.phone || data?.phone || "-",
        "Payment Mode": data?.paymentMode || data?.modeOfPayment || "-",
        "Payment Type": data?.paymentType || data?.subscriptionType || "-",
        Amount: data?.amount ?? data?.price ?? "-",
        "Invoice No.": data?.invoiceNumber || data?.invoiceNo || "-",
        "Payment Date": data?.paymentDate
          ? new Date(data.paymentDate).toLocaleDateString()
          : data?.createdDate
            ? new Date(data.createdDate).toLocaleDateString()
            : data?.createdAt
              ? new Date(data.createdAt).toLocaleDateString()
              : "-",
        Status: data?.status || data?.paymentStatus || "-",
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Payment History");

      const excelBuffer = XLSX.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });

      const file = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      saveAs(file, "payment-history-report.xlsx");
    } catch (error) {
      console.error("Excel download failed:", error);
    }
  };

  useEffect(() => {
    fetchPaymentMode();
    fetchPaymentType();
  }, []);

  async function fetchPaymentMode() {
    try {
      const res = await getPaymentModeReport();
      setPaymentModeOptions(res);
    } catch (error) {
      console.error("Error fetching payment mode data:", error);
    }
  }

  async function fetchPaymentType() {
    try {
      const res = await getPackageTypeReport();
      setPaymentTypeOptions(res);
    } catch (error) {
      console.error("Error fetching payment type data:", error);
    }
  }

  return (
    <>
      <PageTitle activeMenu={"Payment History Report"} motherMenu={"Reports"} />
      <div className="filter cm-content-box box-primary">
        <div className={`content-title`} onClick={() => setOpen(!open)}>
          <div className="cpa">
            <i className="fas fa-filter me-2"></i>Filter
          </div>
          <div className="tools">
            <Link
              to={"#"}
              className={`SlideToolHeader ${open ? "collapse" : "expand"}`}
            >
              <i className="fas fa-angle-up"></i>
            </Link>
          </div>
        </div>
        <Collapse in={open}>
          <div className="cm-content-body form excerpt">
            <div className="card-body">
              <div className="row">
                <div className="col-xl-3 col-sm-6 mb-3">
                  <label className="form-label">Select Tenant</label>
                  <Select
                    value={selectedTenant}
                    options={tenantOptions}
                    onChange={(val) => {
                      setSelectedTenant(val);
                      setPage(0);
                    }}
                    isClearable
                    isLoading={isLoading}
                    filterOption={null} // Disable frontend filtering
                    onInputChange={(value, actionMeta) => {
                      if (actionMeta.action === "input-change") {
                        setTenantSearch(value);
                        setHasMore(true);
                        loadTenants(0, value); // Backend search
                      }
                    }}
                    onMenuScrollToBottom={() => {
                      if (hasMore && !isLoading) {
                        loadTenants(tenantPage + 1, tenantSearch);
                      }
                    }}
                    placeholder="Select Tenant"
                  />
                </div>

                <div className="col-xl-3 col-sm-6 mb-3">
                  <label className="form-label">Payment Mode</label>
                  <Select
                    isSearchable={false}
                    isClearable
                    options={[
                      { value: "", label: "All Payment Mode" },
                      ...(paymentModeOptions || []).map((status) => ({
                        value: status?.key || status?.value || status?.label || status,
                        label: `${status?.label || status?.value || status?.key || status}`,
                      })),
                    ]}
                    className="custom-react-select"
                    onChange={(e) => {
                      setSelectedPaymentMode(e?.value || "");
                      setPage(0);
                    }}
                    placeholder="Select Payment Mode"
                  />
                </div>

                <div className="col-xl-3 col-sm-6 mb-3">
                  <label className="form-label">Payment Type</label>
                  <Select
                    isSearchable={false}
                    isClearable
                    options={[
                      { value: "", label: "All Payment Type" },
                      ...(paymentTypeOptions || []).map((status) => ({
                        value: status?.key || status?.value || status?.label || status,
                        label: `${status?.value || status?.label || status?.key || status}`,
                      })),
                    ]}
                    className="custom-react-select"
                    onChange={(e) => {
                      setSelectedPaymentType(e?.value || "");
                      setPage(0);
                    }}
                    placeholder="Select Payment Type"
                  />
                </div>

                <div className="col-xl-3 col-sm-6 mb-3">
                  <label className="form-label">Start Date</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => {
                      setStartDate(date);
                      setEndDate(null); // reset end date
                      setPage(0);
                    }}
                    maxDate={new Date()}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select start date"
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6 mb-3">
                  <label className="form-label">End Date</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => {
                      setEndDate(date);
                      setPage(0);
                    }}
                    minDate={startDate}
                    maxDate={
                      startDate
                        ? new Date(
                            new Date(startDate).setDate(
                              startDate.getDate() + 90,
                            ),
                          )
                        : new Date()
                    }
                    disabled={!startDate}
                    dateFormat="yyyy-MM-dd"
                    className="form-control"
                    placeholderText="Select end date"
                    isClearable
                  />
                </div>

                <div className="col-xl-3 col-sm-6 mb-3 d-flex align-items-end">
                  <button
                    type="button"
                    className="btn btn-success"
                    style={{ height: "2.8rem" }}
                    onClick={downloadExcel}
                  >
                    <i className="fas fa-file-excel me-2"></i> Download
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
      </div>

      <Row>
        <Tab.Container defaultActiveKey={"List"}>
          <div className="col-lg-12">
            <Tab.Content className="row tab-content">
              {/* LIST VIEW */}
              <Tab.Pane eventKey="List" className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <div className="dataTables_wrapper no-footer">
                      <div className="justify-content-between d-sm-flex mb-3">
                        {/* PAGE SIZE DROPDOWN */}
                        <div className="dataTables_length">
                          <label className="d-flex align-items-center">
                            Show
                            <Dropdown className="search-drop ms-2 me-2">
                              <Dropdown.Toggle
                                as="div"
                                className="search-drop-btn"
                              >
                                {size}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {[10, 20, 30].map((val) => (
                                  <Dropdown.Item
                                    key={val}
                                    onClick={() => {
                                      setSize(val);
                                      setPage(0);
                                    }}
                                  >
                                    {val}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                            entries
                          </label>
                        </div>

                        {/* SEARCH */}
                        <div className="dataTables_filter">
                          <label>
                            Search :{" "}
                            <input
                              type="search"
                              className=""
                              placeholder=""
                              value={search}
                              onChange={handleSearchChange}
                            />
                          </label>
                        </div>
                      </div>

                      {/* TABLE WITH HORIZONTAL SCROLL */}
                      <div className="table-responsive">
                        <table
                          id="example4"
                          className="display dataTable no-footer w-100"
                        >
                          <thead>
                            <tr>
                              {theadData.map((item, ind) => (
                                <th
                                  key={ind}
                                  onClick={() => {
                                    if (item.sortingVale === "action") return;
                                    SotingData(item.sortingVale);
                                    setIconDate((prevState) => ({
                                      complete: !prevState.complete,
                                      ind: ind,
                                    }));
                                  }}
                                  style={
                                    item.sortingVale !== "action"
                                      ? { cursor: "pointer" }
                                      : {}
                                  }
                                >
                                  {item.heading}
                                  {item.sortingVale !== "action" && (
                                    <span>
                                      {ind !== iconData.ind && (
                                        <i
                                          className="fa fa-sort ms-2 fs-12"
                                          style={{ opacity: "0.3" }}
                                        />
                                      )}
                                      {ind === iconData.ind &&
                                        (iconData.complete ? (
                                          <i
                                            className="fa fa-arrow-down ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ) : (
                                          <i
                                            className="fa fa-arrow-up ms-2 fs-12"
                                            style={{ opacity: "0.7" }}
                                          />
                                        ))}
                                    </span>
                                  )}
                                </th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {!loading &&
                              userData.map((data, ind) => (
                                <tr key={ind}>
                                  <td>{currentStart * size + ind + 1}</td>
                                  <td>
                                    {data?.tenant?.name ||
                                      data?.tenantName ||
                                      data?.name ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data?.tenant?.email ||
                                      data?.email ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data?.tenant?.phone ||
                                      data?.phone ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data?.paymentMode ||
                                      data?.modeOfPayment ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data?.paymentType ||
                                      data?.subscriptionType ||
                                      "-"}
                                  </td>
                                  <td>{data?.amount ?? data?.price ?? "-"}</td>
                                  <td>
                                    {data?.invoiceNumber ||
                                      data?.invoiceNo ||
                                      "-"}
                                  </td>
                                  <td>
                                    {data?.paymentDate
                                      ? new Date(
                                          data.paymentDate,
                                        ).toLocaleDateString()
                                      : data?.createdDate
                                      ? new Date(
                                          data.createdDate,
                                        ).toLocaleDateString()
                                      : data?.createdAt
                                      ? new Date(
                                          data.createdAt,
                                        ).toLocaleDateString()
                                      : "-"}
                                  </td>
                                  <td>
                                    {data?.status ||
                                      data?.paymentStatus ||
                                      "-"}
                                  </td>
                                </tr>
                              ))}

                            {loading && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  Loading...
                                </td>
                              </tr>
                            )}

                            {!loading && userData.length === 0 && (
                              <tr>
                                <td colSpan={10} className="text-center">
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {/* PAGINATION FOOTER */}
                      <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
                        <div className="dataTables_info">
                          <span>
                            Page{" "}
                            <strong>
                              {currentStart + 1} of {totalPages}
                            </strong>
                          </span>
                        </div>
                        <div className="dataTables_paginate paging_simple_numbers">
                          <Link
                            className={`paginate_button previous ${
                              page === 0 ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page > 0) setPage(page - 1);
                            }}
                          >
                            Previous
                          </Link>

                          <Link
                            className={`paginate_button next ${
                              page + 1 >= totalPages ? "disabled" : ""
                            }`}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              if (page + 1 < totalPages) setPage(page + 1);
                            }}
                          >
                            Next
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab.Pane>
            </Tab.Content>
          </div>
        </Tab.Container>
      </Row>
    </>
  );
};

export default PaymentHistoryReport;
